export var AccidentAssignmentAtaCodes;
(function (AccidentAssignmentAtaCodes) {
    AccidentAssignmentAtaCodes["DamageParts"] = "88001A41";
    AccidentAssignmentAtaCodes["DamageLabor"] = "88001A40";
    AccidentAssignmentAtaCodes["PaintParts"] = "88001006";
    AccidentAssignmentAtaCodes["PaintLabor"] = "88001005";
    AccidentAssignmentAtaCodes["MechLabor"] = "88001004";
    AccidentAssignmentAtaCodes["Other"] = "88002A05";
})(AccidentAssignmentAtaCodes || (AccidentAssignmentAtaCodes = {}));
